import {
    GridCsvExportOptions,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarExport,
    GridToolbarFilterButton,
    GridToolbarQuickFilter,
    useGridApiContext
} from "@mui/x-data-grid";
import {
    Autocomplete, Badge,
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    Divider,
    Link, Skeleton,
    Snackbar,
    Stack,
    TextField, Typography
} from "@mui/material";
import React, {useEffect, useMemo, useState} from "react";
import {
    AddCircle,
    AddTask,
    DownloadForOffline,
    Downloading,
    FilterNone,
    LibraryAddCheck, Restaurant,
    Save
} from "@mui/icons-material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import _, {isEmpty} from 'lodash'
import ColumnsService from "../../services/columns.service";
import {Alert} from "@mui/lab";
import useAxios from "axios-hooks";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import {getId} from "../../services/utils";
import CustomTooltip from "../CustomTooltip";
import {customTheme} from "../../theme/customTheme";
import {useParams} from "react-router-dom";

export const GridToolbarButton = ({startIcon, label, onClick, disabled}) => {
    return (
        <Button size="small" startIcon={startIcon} onClick={onClick} disabled={disabled}>
            {label}
        </Button>
    )
}

const CustomToolbar = ({buttons = [], totalExport = true}) => {
    const {event_id} = useParams()

    const apiRef = useGridApiContext();
    const handleExport = (options: GridCsvExportOptions) =>
        apiRef.current.exportDataAsCsv(options);

    const [{data: config}, refetchConfig] = useAxios(ColumnsService.columnsUrl(event_id), {
        method: "GET", useCache: false
    })

    const defaultExportModel = useMemo(() => {
        if(!config)
            return null
        const _defaultExportModel = []
        config.exportModels?.default?.fields.forEach((col) => {
            _defaultExportModel.push(apiRef.current.getColumn(col))
        })
        return _defaultExportModel
    }, [config])

    const exportModels = useMemo(() => {
        if(!config)
            return null

        return config.exportModels || []
    }, [config])

    return (
        <GridToolbarContainer >
            {buttons?.map((button, index) => <div key={index}>{button}</div>) /** eventuali buttons aggiuntivi custom */}
            {<GridToolbarColumnsButton />}
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            {<GridToolbarExport csvOptions={{
                utf8WithBom: true,
            }}/> /** pulsante export di default */}
            {/*<GridToolbarButton
                startIcon={<Download/>}
                label={"Esporta colonne visibili"}
                onClick={handleExport}
            />*/}
            {/*
                exportedFields &&
                    <GridToolbarButton
                        startIcon={<Downloading/>}
                        label={"Esporta colonne custom"}
                        onClick={() => {
                            handleExport({utf8WithBom: true, fields: exportedFields})
                        }}
                    />
            */}
            {
                totalExport &&
                    <GridToolbarButton
                        startIcon={<DownloadForOffline/>}
                        label={"Esporta tutte le colonne"}
                        onClick={() => {
                            handleExport({utf8WithBom: true, allColumns: true})
                        }}
                    />
            }
            {defaultExportModel && exportModels && <CustomExportButton apiRef={apiRef} exportModels={exportModels} defaultExportModel={defaultExportModel} refetchConfig={refetchConfig} handleExport={handleExport}/>}
            <Box marginLeft={'auto'}>
                <GridToolbarQuickFilter/>
            </Box>
        </GridToolbarContainer>
    );
}

export default CustomToolbar

const CustomExportButton = ({apiRef, exportModels, defaultExportModel, refetchConfig, handleExport}) => {
    const [exportConf, setExportConf] = useState()

    useEffect(() => {
        if(exportModels)
            setExportConf(Object.values(exportModels)[0])
    }, [exportModels])

    useEffect(() => {
        if(exportConf) {
            setExportState({
                ...exportState,
                id: exportConf.id,
                selected: exportConf.fields.map((col) => (
                    apiRef.current.getColumn(col)
                )),
                fileName: exportConf.label
            })
        }
    }, [exportConf])

    const [exportState, setExportState] = useState({
        openDialog: false,
        id: "",
        fileName: `Export registrazioni`,
        options: apiRef.current.getAllColumns(),
        selected: defaultExportModel,
    })

    /*useEffect(() => {
        if(defaultExportModel)
            setExportState({...exportState, selected: defaultExportModel})
    }, [defaultExportModel])*/

    const [message, setMessage] = useState({show: false, loading: false, text: "", severity: "info"})

    const handleOpenExportDialog = () => {
        refetchConfig()
        setExportState({...exportState, openDialog: true})
    }

    const handleClose = () => {
        setExportState({
            ...exportState,
            openDialog: false,
        })
    }

    const handleCustomExport = () => {
        handleExport({
            fileName: `${exportState.fileName} - ${(new Date()).toLocaleString()}`,
            utf8WithBom: true,
            fields: _.map(exportState.selected, (selectedCol) => (selectedCol.field)),
        })
    }

    const handleSaveConfiguration = () => {
        setMessage({...message, loading: true})
        setTimeout(function () {
            const cols = _.map(exportState.selected, (selectedCol) => (selectedCol.field))
            const id = exportState?.id || getId(exportState.fileName)
            const data = {
                fields: cols,
                label: exportState.fileName,
                id: id
            }
            ColumnsService.saveColumsToExport(id, data)
                .then((res) => {
                    setMessage({show: true, loading: false, text: "Configurazione salvata con successo", severity: "success"})
                    refetchConfig()
                })
                .catch((err) => {
                    setMessage({show: true, loading: false, text: "Configurazione non salvata", severity: "error"})
                })
        }, 200);
    }

    const handleCloseError = () => {
        setMessage({...message, show: false})
    }

    function handleChangeSelectedConf(event) {
        setExportConf(event.target.value)
    }

    function handleChangeConfLabel(e) {
        setExportState({
            ...exportState,
            fileName: e.target.value
        })
    }

    function handleNewConf() {
        setExportState({
            openDialog: true,
            id: null,
            fileName: ``,
            options: apiRef.current.getAllColumns(),
            selected: [apiRef.current.getColumn('id'), apiRef.current.getColumn('email'), ],
        })
        setExportConf(null)
    }

    function validConf() {
        return (!_.isEmpty(exportState.selected)) && !!exportState.fileName;
    }

    return (<>
    <GridToolbarButton
        startIcon={<Downloading/>}
        label={"Export custom"}
        onClick={handleOpenExportDialog}
    />
    <Dialog open={exportState.openDialog} onClose={handleClose} fullWidth maxWidth={"sm"}>
            <DialogTitle>Esporta Dati</DialogTitle>
            <DialogContent>
                <Box my={1}>
                    <Stack direction={'row'} alignItems={'center'}>
                        <TextField variant={'outlined'}
                               margin={'dense'}
                               size={'small'}
                               fullWidth
                               select
                               id={'exportConf'}
                               name={'exportConf'}
                               label={'Configurazione'}
                               //defaultValue={exportModels.default}
                               value={exportConf}
                               onChange={handleChangeSelectedConf}
                        >
                            {isEmpty(Object.values(exportModels)) &&
                                <Box px={2}>
                                    <Typography fontStyle={'italic'}>Nessuna configurazione creata</Typography>
                                </Box>}
                            {
                                Object.values(exportModels).map((option) => (
                                    <MenuItem key={option.label} value={option} children={
                                        <Stack direction={'row'} spacing={1}>
                                            <div>{option.label}</div>
                                        </Stack>
                                    }/>
                                ))}
                        </TextField>
                        <CustomTooltip
                            title={"Aggiungi una nuova configurazione di export"}
                            children={<IconButton onClick={handleNewConf}><AddCircle/></IconButton>}
                        />
                    </Stack>

                    {!exportState.id && <Divider sx={{marginTop: '4%'}}>Aggiungi nuova configurazione</Divider>}

                    <TextField fullWidth
                               margin={'dense'}
                               size={'small'}
                               label="Nome del file"
                               required
                               defaultValue={exportState.fileName}
                               value={exportState.fileName}
                               onChange={handleChangeConfLabel}
                    />
                    <Autocomplete
                        renderInput={(params) =>
                            <TextField {...params}
                                       required
                                       label="Scegli le colonne"
                                       margin={'normal'}
                            />}
                        options={exportState.options||[]}
                        multiple
                        limitTags={5}
                        value={exportState.selected}
                        onChange={(event, newSelection) => {
                            setExportState({...exportState, selected: newSelection});
                        }}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.headerName}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <Checkbox
                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.headerName}
                            </li>
                        )}
                        renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                                <Chip label={option?.headerName} {...getTagProps({ index: index })} />
                            ))}
                    />
                </Box>
                <Box display={'flex'} alignItems={'center'}>
                    <Link component={Button}
                          variant={"body2"}
                          onClick={handleSaveConfiguration}
                          startIcon={<Save color={'accent'}/>}
                          disabled={!validConf()}
                    >
                        {!exportState.id ? 'Aggiungi la nuova configurazione' : 'Salva la configurazione' }
                    </Link>
                    {message?.loading && <CircularProgress size={18}/>}
                </Box>
                <Snackbar open={message?.show} autoHideDuration={6000} onClose={handleCloseError}>
                    <Alert elevation={6} onClose={handleCloseError} variant={"filled"} severity={message?.severity}
                            sx={{width: '100%'}}>
                        {message?.text}
                    </Alert>
                </Snackbar>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Annulla</Button>
                <Button disabled={_.isEmpty(exportState.selected)} variant={'contained'} onClick={handleCustomExport}>Esporta</Button>
            </DialogActions>
    </Dialog>
    </>)
}